module.exports = __webpack_public_path__ + "img/chart-simple-solid.10cf0f52.svg";